import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { Box } from "@mui/material";
import { type } from "@testing-library/user-event/dist/type";

const ImageCarousel = (props) => {
  const { images } = props
  return (
    <Carousel dynamicHeight={true} emulateTouch className="rounded">
      {
        images.map((image, i) => (
          <Box key={i + image.file.substring(0, 10)} >
            <img src={image.file} alt={"auto"} className='card-img-top rounded w-100' style={{ width: '100%', height: "100%", objectFit: "contain", objectPosition: "center" }} />
          </Box>
        ))
      }
    </Carousel >
  );

}

export default ImageCarousel